import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => {
  return {
    msgIcon: {
      border: "solid 4px #8C9CAC",
      height: 70,
      width: 70,
      textAlign: "center",
      padding: "15px 0",
      borderRadius: "50%",
      marginBottom: 10,
      "& svg": {
        color: "#8C9CAC"
      }
    }
  };
});

export default useStyles;
